/**
 * Left-column stat cards for a match result: a big match-score percentage and
 * a separate exclusion-points count, each in its own bordered card.
 *
 * Two colour systems:
 *   - Match score: <50 → grey, <70 → yellow, ≥70 → green (visual sugar; the
 *     engine never auto-zeros the score).
 *   - Exclusion count: coloured by the engine's `exclusionBand` directly
 *     (spec §"Identify Binary Exclusion Score").
 */
import { Label } from 'semantic-ui-react';
import { ExclusionBand } from '../types';

interface Props {
  score: number;
  exclusionTotal: number;
  exclusionBand: ExclusionBand;
  killed: boolean;
}

const scoreColor = (score: number): 'grey' | 'yellow' | 'green' => {
  if (score < 50) return 'grey';
  if (score < 70) return 'yellow';
  return 'green';
};

export default function HeaderScore({
  score,
  exclusionTotal,
  exclusionBand,
  killed,
}: Props) {
  return (
    <div className="buyer-profile-match__header">
      <div className="buyer-profile-match__stat-card buyer-profile-match__stat-card--score">
        <span
          className={`buyer-profile-match__stat-value buyer-profile-match__stat-value--${scoreColor(
            score
          )}`}
        >
          {score}%
        </span>
        <span className="buyer-profile-match__stat-label">Match score</span>
      </div>

      <div className="buyer-profile-match__stat-card buyer-profile-match__stat-card--exclusion">
        <span
          className={`buyer-profile-match__stat-value buyer-profile-match__stat-value--sm buyer-profile-match__stat-value--${exclusionBand}`}
        >
          {exclusionTotal}
        </span>
        <span className="buyer-profile-match__stat-label">
          Exclusion{exclusionTotal === 1 ? '' : 's'}
        </span>
        {killed ? (
          <Label color="red" size="small" className="buyer-profile-match__killed-tag">
            Auto-killed
          </Label>
        ) : null}
      </div>
    </div>
  );
}
